// Event listener for clicks on elements with the 'selected-sort-custom' class
document.addEventListener("click", function (event) {
  if (event.target.classList.contains("selected-sort-custom")) {
    let selectElement = event.target.closest(".select")
    if (selectElement) {
      selectElement.classList.toggle("active")
    }
  }
})

// Event listener for clicks anywhere in the document
document.body.addEventListener("click", function (event) {
  if (!event.target.closest(".facet-filters__field .select")) {
    let selectElements = document.querySelectorAll(
      ".facet-filters__field .select",
    )
    selectElements.forEach(function (element) {
      element.classList.remove("active")
    })
  }
})

// Ensure at least one radio button is checked
let radios = document.querySelectorAll(
  '.multiple-custom-sort-options input[type="radio"]',
)
let isChecked = Array.from(radios).some((radio) => radio.checked)
if (!isChecked && radios.length > 0) {
  radios[0].checked = true
}
